<template>
  <RouterView/>
  <CModalStack/>
  <LoadingModal/>
  <CTooltip v-if="tooltip" :info="tooltip"/>
</template>

<script setup lang="ts">
  import { computed, onMounted, onUnmounted } from 'vue';
  import CModalStack from './general/components/CModalStack.vue';
  import CTooltip from './general/components/tooltip/CTooltip.vue';
  import TooltipService from './general/services/TooltipService';
  import LoadingModal from './shared/components/LoadingModal.vue';
  import viewEvents, { EscapePressed } from './shared/view/viewEvents';

  const tooltip = computed(() => TooltipService.getCurrent());

  function onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      viewEvents.fire(new EscapePressed());
    }
  }

  onMounted(() => document.addEventListener('keydown', onKeyDown));
  onUnmounted(() => document.removeEventListener('keydown', onKeyDown));
</script>
